const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20webtoon%20style%20illustration%20of%20an%20elegant%20couple%20in%20modern%20office%20attire%20sharing%20a%20tender%20moment%20near%20a%20city%20window%2C%20soft%20warm%20lighting%20with%20golden%20hour%20tones%2C%20detailed%20character%20expressions%2C%20beautiful%20cityscape%20background%2C%20polished%20professional%20artwork&width=600&height=400&seq=featured-manga-01&orientation=landscape',
    title: '社内恋爱法则',
    tag: '韩漫热门',
    desc: '霸道总裁与职场新人的心跳恋曲，全网点击破亿',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20manhua%20style%20illustration%20of%20a%20powerful%20cultivator%20standing%20on%20a%20mountain%20peak%20with%20flowing%20robes%20and%20glowing%20spiritual%20energy%2C%20dramatic%20clouds%20and%20sunset%20sky%2C%20ancient%20Chinese%20architecture%20in%20distance%2C%20dynamic%20heroic%20pose%2C%20rich%20golden%20and%20crimson%20color%20palette&width=600&height=400&seq=featured-manga-02&orientation=landscape',
    title: '重生之都市仙尊',
    tag: '国漫热榜',
    desc: '修仙大佬重生都市，逆天改命爽燃不止',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Action%20packed%20Japanese%20manga%20style%20illustration%20of%20teenage%20heroes%20battling%20supernatural%20monsters%20with%20magical%20powers%2C%20dynamic%20fight%20scene%20with%20energy%20effects%20and%20speed%20lines%2C%20urban%20Tokyo%20night%20background%20with%20neon%20lights%2C%20bold%20dramatic%20composition%2C%20vibrant%20color%20contrast&width=600&height=400&seq=featured-manga-03&orientation=landscape',
    title: '咒术学院',
    tag: '日漫经典',
    desc: '超能力校园热血战斗，少年们的命运之战',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20webtoon%20style%20illustration%20of%20a%20mysterious%20female%20lead%20in%20traditional%20hanbok%20dress%20standing%20in%20a%20moonlit%20ancient%20palace%20garden%2C%20ethereal%20atmosphere%20with%20floating%20cherry%20blossom%20petals%2C%20soft%20silver%20moonlight%2C%20romantic%20historical%20fantasy%20aesthetic%2C%20dreamy%20pastel%20color%20tones&width=600&height=400&seq=featured-manga-04&orientation=landscape',
    title: '极道千金',
    tag: '韩漫精选',
    desc: '黑道大小姐的隐秘双重人生，反转连连',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Thrilling%20Chinese%20manhua%20illustration%20of%20a%20detective%20character%20investigating%20a%20mysterious%20crime%20scene%20in%20a%20dark%20alley%2C%20noir%20atmosphere%20with%20dramatic%20shadows%20and%20single%20streetlight%2C%20suspenseful%20mood%2C%20detailed%20urban%20environment%2C%20cinematic%20composition%20with%20rich%20contrast&width=600&height=400&seq=featured-manga-05&orientation=landscape',
    title: '暗夜追踪者',
    tag: '国漫新作',
    desc: '悬疑推理天花板，每一话都让人屏息',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20Japanese%20manga%20illustration%20of%20a%20young%20chef%20in%20a%20magical%20kitchen%20cooking%20with%20glowing%20ingredients%20and%20mythical%20creatures%20as%20sous%20chefs%2C%20warm%20cozy%20atmosphere%20with%20steam%20and%20sparkles%2C%20whimsical%20detailed%20food%20art%2C%20soft%20golden%20lighting%2C%20heartwarming%20colorful%20scene&width=600&height=400&seq=featured-manga-06&orientation=landscape',
    title: '异世界料理人',
    tag: '日漫新番',
    desc: '用美食征服异世界，治愈系冒险物语',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">编辑精选</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑团队精心挑选，本本都是口碑之作
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`汗汗漫画 ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-950/60 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg text-foreground-950 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-600">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}